module.exports = "//static.hsappstatic.net/LoginUI/static-1.14169/img/unsupported-browser.svg"